var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.subscribeQRCode)?_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":_vm.subscribeQRCode}}),_c('div',{staticClass:"tips"},[_vm._v("长按二维码关注公众号")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }